import React from "react";

export default function ImagePath(props) {
  // PROPS ARE COMING FROM ProductLandings
  const { sect } = props;
  return (
    <>
      {sect.contentImagePath.map((image) => {
        return (
          <img className={sect.imageType} key={image} src={image} alt={image} />
        );
      })}
    </>
  );
}
